export enum FieldTypes {
  MultipleChoice = 0,
  RadioButtons = 1,
  DropDownList = 2,
  Text = 3,
  MultiLineText = 4,
  DatePicker = 5,
  DateTimePicker = 6,
  Checkbox = 7,
  Display = 8,
  Autocomplete = 9,
  MultipleAutocomplete = 10,
  RichTextEditor = 11,
  RepeatableFieldGroup = 12,
  Action = 13,
  FieldArray = 14,
  MultipleAutocompleteWithSearch = 15,
  Header = 16,
}
